export const rotateButtonImage = new Image();
rotateButtonImage.src = '/assets/images/sketch-tool/rotate.svg';


export const resizeButtonImage = new Image();
resizeButtonImage.src = '/assets/images/sketch-tool/resize.svg';

export const duplicateButtonImage = new Image();
duplicateButtonImage.src = '/assets/images/sketch-tool/add.svg';